import React from 'react';
import { useEffect } from 'react';
import clsx from 'clsx';

import useSearchInput from '@dashboard/hooks/useSearchInput';
import { XMarkIcon } from '@heroicons/react/24/outline';

import TextInput from './TextInput';
import Label from './Label';

const SearchInput = ({ name, placeholder, onChange, label, initialValue = '', className }) => {
  const { searchInput, setSearchInput, search } = useSearchInput(initialValue);

  useEffect(() => {
    onChange(search);
  }, [search]);

  return (
    <div className={clsx('w-64', className)}>
      {label && <Label>{label}</Label>}
      <div className="relative flex items-center">
        <TextInput
          border
          name={name}
          onChange={e => setSearchInput(e.target.value)}
          placeholder={placeholder}
          value={searchInput}
          type="search"
        />

        {searchInput.length > 0 && (
          <button
            onClick={() => setSearchInput('')}
            className="flex items-center absolute right-0 top-0 bottom-0 p-1.5 m-px bg-white text-gray-300 hover:text-gray-400 transition-colors rounded"
          >
            <XMarkIcon className="h-4 w-4"></XMarkIcon>
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
